<template>
    <v-dialog v-model="dialog" persistent max-width="400px">
        <v-card class="pa-2">
            <v-card-title>
                <h2>Atención</h2>
            </v-card-title>
            <v-card-text class="px-0">
                <v-container fluid>
                    <v-row>
                        <p class="pb-0 mx-auto mb-0">
                            ¿Realmente desea eliminar la cuenta?
                        </p>
                        <p class="pb-0 mx-auto mb-0 red--text">
                            Esta acción no se puede revertir
                        </p>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" @click="remove" text color="error">Aceptar</v-btn>
                <v-btn :disabled="loading" type="button" :color="color" @click="$parent.delete_dialog = false" text>Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog', 'item', 'delete_url'],
    data: () => ({
        loading: false,
        color:"#000"
    }),

    methods:{
        remove:function(){
            this.loading = true
            let data = new Object()
            data.id = this.item.id

            axios.post(this.delete_url, data).then(response => {
                this.loading = false
                this.$parent.delete_dialog = false

                iziToast.success({
                    title:"Correcto",
                    message:"Usuario eliminado correctamente",
                    position:"topRight"
                })

                this.$parent.getData()

            }).catch(error => {
                this.$parent.delete_dialog = false
                this.loading = false
                iziToast.error({
                    title:"Error",
                    message:"Ha ocurrido un error en la comunicación con el servidor",
                    position:"topRight"
                })
            })
        }
    }
}
</script>
